export default "__VITE_ASSET__DUlCN8lm__"